import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=1513a0e4&scoped=true"
import script from "./Flight.vue?vue&type=script&lang=js"
export * from "./Flight.vue?vue&type=script&lang=js"
import style0 from "./Flight.vue?vue&type=style&index=0&id=1513a0e4&prod&lang=css"
import style1 from "./Flight.vue?vue&type=style&index=1&id=1513a0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513a0e4",
  null
  
)

export default component.exports